/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { Transition2Component} from './transition_2.component';

export class Transition2Validation extends IValidator {

       constructor(private component: Transition2Component) { super(); }

       private success: boolean;

       public validate(): boolean {

            this.success = true;

            // add your valdation here!

            return this.success;

       }
}

